import { DataSource, FormOption } from '@qfa/forms';
import { useSignalActionSetOptionsLazyQuery } from '@kinetic-ui/data-layer';
import { useCallback } from 'react';

export const useActionSetsDataSource = (): DataSource<FormOption[]> => {
  const [getActionSets] = useSignalActionSetOptionsLazyQuery();
  const load = useCallback(async () => {
    const { data } = await getActionSets();
    return (data?.signalActionSetOptions ?? []) as FormOption[];
  }, [getActionSets]);
  return { load };
};
